// 👉 Paste images Public/hero folder ONLY

//import Slider1 from "../components/images/Carousel1.jpg";
//import Slider2 from "../components/images/Carousel2.jpg";
//import Slider3 from "../components/images/Carousel3.jpg";
//import Slider4 from "../components/images/hero.jpg";
// 👉 add more images here ONLY

const heroSlides = [
    {
        img: "/hero/sujaramaha_welcome.webp",   // 🔥 public path
        alt: "Insurance services banner",
        title: "Trusted Insurance Partner",
        subtitle: "Vehicle • Health • Travel Insurance",
        cta: "Get Instant Quote",
        link: "/get-quote",
        priority: true,
    },
    {
        img: "/hero/sujaramaha_all_services.webp",   // 🔥 public path
        alt: "Insurance services banner",
        title: "Trusted Insurance Partner",
        subtitle: "Vehicle • Health • Travel Insurance",
        cta: "Get Instant Quote",
        link: "/get-quote",
        priority: true,
    },
    {
        img: "/hero/sujaramaha_computer_printer.webp",
        alt: "Vehicle insurance banner",
        title: "Vehicle Insurance Made Easy",
        subtitle: "Best price • Fast claims",
        cta: "Insure Your Vehicle",
        link: "/vehicle-insurance",
    },
    {
        img: "/hero/sujaramaha_cctv.webp",
        alt: "Health insurance banner",
        title: "Health Insurance for Your Family",
        subtitle: "Cashless hospitals across India",
        cta: "View Health Plans",
        link: "/health-insurance",
    },
    {
        img: "/hero/sujaramaha_insurances.webp",
        alt: "Travel insurance banner",
        title: "Travel Insurance Made Simple",
        subtitle: "Worldwide coverage • Easy claims",
        cta: "Explore Travel Plans",
        link: "/travel-insurance",
    },
    {
        img: "/hero/sujaramaha_solar_water_heater.webp",
        alt: "Travel insurance banner",
        title: "Travel Insurance Made Simple",
        subtitle: "Worldwide coverage • Easy claims",
        cta: "Explore Travel Plans",
        link: "/travel-insurance",
    },
    {
        img: "/hero/sujaramaha_inverter.webp",
        alt: "Travel insurance banner",
        title: "Travel Insurance Made Simple",
        subtitle: "Worldwide coverage • Easy claims",
        cta: "Explore Travel Plans",
        link: "/travel-insurance",
    },
    {
        img: "/hero/sujaramaha_water_purifier.webp",
        alt: "Travel insurance banner",
        title: "Travel Insurance Made Simple",
        subtitle: "Worldwide coverage • Easy claims",
        cta: "Explore Travel Plans",
        link: "/travel-insurance",
    },
    {
        img: "/hero/sujaramaha_home_appliances_s.webp",
        alt: "Travel insurance banner",
        title: "Travel Insurance Made Simple",
        subtitle: "Worldwide coverage • Easy claims",
        cta: "Explore Travel Plans",
        link: "/travel-insurance",
    },
    
    {
        img: "/hero/sujaramaha_home_appliances.webp",
        alt: "Travel insurance banner",
        title: "Travel Insurance Made Simple",
        subtitle: "Worldwide coverage • Easy claims",
        cta: "Explore Travel Plans",
        link: "/travel-insurance",
    },
    {
        img: "/hero/sujaramaha_solar.webp",
        alt: "Travel insurance banner",
        title: "Travel Insurance Made Simple",
        subtitle: "Worldwide coverage • Easy claims",
        cta: "Explore Travel Plans",
        link: "/travel-insurance",
    },
];

export default heroSlides;
